import { Box, useMediaQuery } from '@mui/material'
import React from 'react'
import LoginForm from '../components/login/loginForm'
import CardImageSignin from '../components/signin/cardImageSignin'
import passwordPic from "../assets/image/forgetPassword.png";
import ForgetPassForm from '../components/forgetPassForm';
import logo from "../assets/image/logo.png";

export default function ForgetPassword() {
  const lg = useMediaQuery("(max-width:850px)");
  return (
    <Box display='flex' alignItems='center' justifyContent='left' bgcolor="white" width="100vw" height="100vh" position="fixed">
        <Box height='100%' width='100%' >
            <Box m='30px' >
            <img style={{width:"100px",height:"auto"}} src={logo} /> 
            </Box>
            <Box display='grid' alignItems={'center'}  height='50%'>
                <ForgetPassForm />
            </Box>
        </Box>
     {!lg&& <Box className="cardLogin" style={{background: 'linear-gradient(180deg, #6cbbc7 0%, #6cbbc7 100%)'}} ml='14px'>
      <CardImageSignin
      mt='70px'
          image={passwordPic}
          title="فراموشی رمزعبور"
          text="برای بازیابی رمزعبور، شماره تلفن همراه خود را وارد نمایید و سپس رمزعبور جدید خود را وارد نمائید."
        />
      </Box>}
    </Box>
  )
}
